const FALLBACK_NUMBER = "628812551877";

export function waNumber(settings) {
  const raw = settings?.whatsapp_number || FALLBACK_NUMBER;
  return raw.replace(/\D/g, "");
}

export function waLink(settings, message) {
  return `https://wa.me/${waNumber(settings)}?text=${encodeURIComponent(message)}`;
}

export const MSG = {
  general:
    "Halo Beyond Travel, saya ingin konsultasi Land Arrangement. Mohon informasi paket dan quotation. Terima kasih.",
  destination: (name) =>
    `Halo Beyond Travel, saya tertarik dengan ${name} Land Arrangement. Mohon informasi paket, itinerary, fasilitas, dan quotation.`,
  package: (title) =>
    `Halo Beyond Travel, saya tertarik dengan paket ${title}. Mohon informasi itinerary, fasilitas, harga, dan ketersediaan.`,
  custom:
    "Halo Beyond Travel, saya ingin membuat Custom Trip. Mohon bantuan untuk menyusun itinerary dan quotation perjalanan saya.",
  group:
    "Halo Beyond Travel, saya ingin request proposal untuk Group / Corporate Travel. Mohon informasi lebih lanjut.",
  lead: (f) =>
    `Halo Beyond Travel, saya ingin konsultasi Land Arrangement untuk ${f.destination || "liburan"}. Saya berencana bepergian dengan ${f.pax || "-"} pada ${f.date || "-"}. Mohon informasi paket dan quotation. Terima kasih.`,
};
